@for (v of views; track v) {
  <li class="nav-item d-flex align-self-stretch">
    @if (!loading && profile.can('view-' + v.name.toLowerCase())) {
      <a class="nav-link d-flex align-items-center" [routerLink]="'/' + v.path" routerLinkActive="active" placement="bottom" ngbTooltip="{{v.name}}">
        <con-icon-by-name [iconName]="v.icon" [mutations]="['lg','fw']"></con-icon-by-name>
      </a>
    }
  </li>
}
